import React, { useEffect } from "react";
import Filter from "./Filter";
import Loading from "../../../../components/ui/Loading/Loading";
import Button from "../../../../components/ui/Button/Button";
import { EventTable } from "./event-table";
import { useNavigate } from "react-router-dom";

const EventBB = () => {
  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const [submittedFilter, setSubmittedFilter] = React.useState({});
  const [searchBy, setSearchBy] = React.useState("title");
  const [searchByValue, setSearchByValue] = React.useState("");
  const [sortFilter, setSortFilter] = React.useState({});
  const [isResetted, setIsResetted] = React.useState(false);
  const [isResetting, setIsResetting] = React.useState(false);
  const filters = { ...submittedFilter, ...sortFilter };
  const resettedFilter = { ...sortFilter };
  const onChangeSearchBy = (id) => {
    setSearchBy(id);
  };

  const onSubmitFilter = () => {
    setIsResetted(false);
    setSubmittedFilter({
      ...selectedFilter,
      [searchBy]: searchByValue,
    });
  };

  const onResetFilter = () => {
    setSelectedFilter({});
    setSubmittedFilter({});
    setSearchByValue("");
    setIsResetting(true);
    setIsResetted(true);
  };

  useEffect(() => {
    if (isResetting) {
      setTimeout(() => {
        setIsResetting(false);
      }, 500);
    }
  }, [isResetting]);

  const onChangeSearchByValue = (value) => {
    setSearchByValue(value);
  };

  useEffect(() => {
    if (selectedFilter?.orderBy !== undefined) {
      setSortFilter({
        orderBy: selectedFilter["orderBy"],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter?.orderBy]);

  const handleAddEvent = () => {
    navigate("event/register");
  };

  return (
    <>
      <div className="flex justify-end my-2">
        <Button primary text="이벤트 등록" onClick={handleAddEvent} />
      </div>
      {isResetting ? (
        <Loading />
      ) : (
        <>
          {isResetted ? (
            <Filter
              onSubmitFilter={onSubmitFilter}
              filter={selectedFilter}
              onFilter={setSelectedFilter}
              onResetFilter={onResetFilter}
              onChangeSearchBy={onChangeSearchBy}
              onChangeSearchByValue={onChangeSearchByValue}
            />
          ) : (
            <Filter
              onSubmitFilter={onSubmitFilter}
              filter={selectedFilter}
              onFilter={setSelectedFilter}
              onResetFilter={onResetFilter}
              onChangeSearchBy={onChangeSearchBy}
              onChangeSearchByValue={onChangeSearchByValue}
            />
          )}
        </>
      )}
      <EventTable filter={isResetted ? resettedFilter : filters} />
    </>
  );
};

export default EventBB;
